/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthSubmissionMode = {
    Manual: 'manual',
    Automated: 'automated',
    Efax: 'efax',
} as const;
export type PalReauthSubmissionMode = typeof PalReauthSubmissionMode[keyof typeof PalReauthSubmissionMode];


export function instanceOfPalReauthSubmissionMode(value: any): boolean {
    for (const key in PalReauthSubmissionMode) {
        if (Object.prototype.hasOwnProperty.call(PalReauthSubmissionMode, key)) {
            if (PalReauthSubmissionMode[key as keyof typeof PalReauthSubmissionMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalReauthSubmissionModeFromJSON(json: any): PalReauthSubmissionMode {
    return PalReauthSubmissionModeFromJSONTyped(json, false);
}

export function PalReauthSubmissionModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionMode {
    return json as PalReauthSubmissionMode;
}

export function PalReauthSubmissionModeToJSON(value?: PalReauthSubmissionMode | null): any {
    return value as any;
}

export function PalReauthSubmissionModeToJSONTyped(value: any, ignoreDiscriminator: boolean): PalReauthSubmissionMode {
    return value as PalReauthSubmissionMode;
}

